import { Translatable } from "@icc/shared/helpers";

export class SteelMountingAnchor {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do wydruków */
    printCode: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Odległość od krawędzi skrzynki [mm] */
    distanceFromBoxSide?: number;
    /** Odległość między kotwami [mm] */
    distanceBetween?: number;
    /** Ilość kotew */
    amount?: number;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
